const listeners = new Set();

export function registerMetricsListener (fn) {
  listeners.add(fn);

  return () => {
    listeners.delete(fn);
  };
}

export function deregisterMetricsListener (fn) {
  listeners.delete(fn);
}

export function emitMetric (event) {
  for (const listener of listeners) {
    try {
      listener(event);
    } catch (e) {
      console.error('Metrics listener failed', e);
    }
  }
}
